import { watcher } from '@feng3d/watcher';
import { WireframeGeometry } from '../../thirdparty/three/imports';
import { BufferGeometry3D } from '../core/BufferGeometry3D';

export class WireframeGeometry3D extends BufferGeometry3D
{
    geometry?: BufferGeometry3D;

    get _geometry()
    {
        if (!this.__geometry)
        {
            this.__geometry = new WireframeGeometry(this.geometry._geometry);
        }

        return this.__geometry;
    }
    declare protected __geometry: WireframeGeometry;

    constructor()
    {
        super();
        watcher.watchs(this as WireframeGeometry3D, ['geometry'], this._invalidate, this);
    }

    destroy()
    {
        watcher.unwatchs(this as WireframeGeometry3D, ['geometry'], this._invalidate, this);
    }
}
